import React, {useState} from 'react';

function commenterName(comment) {
    return comment.Shopper?.name || comment.Shopper?.email || 'Shopper';
}

export default function BlogComments({
    comments = [],
    meta = {},
    onLoadMore,
    onReply,
    onVisibility,
}) {
    const [replyingTo, setReplyingTo] = useState('');
    const [reply, setReply] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');

    const run = async action => {
        setBusy(true);
        setError('');
        try {
            await action();
        } catch (nextError) {
            setError(nextError.message);
        } finally {
            setBusy(false);
        }
    };

    return <section className="content-editor-panel content-comments"
        aria-labelledby="blog-comments-title">
        <header className="content-editor-panel-header">
            <div>
                <h2 id="blog-comments-title">Comments</h2>
                <p>{meta.total || comments.length} total</p>
            </div>
        </header>
        {error && <p className="flash error" role="alert">{error}</p>}
        {comments.length === 0 && <p className="help">No comments yet.</p>}
        <ol className="content-comment-list">
            {comments.map(comment => <li key={comment.uuid}>
                <header>
                    <strong>{commenterName(comment)}</strong>
                    <small>{comment.createdAt
                        ? new Date(comment.createdAt).toLocaleString()
                        : ''}</small>
                </header>
                <p>{comment.comment}</p>
                <div className="content-media-actions">
                    <button type="button" className="button small" disabled={busy}
                        onClick={() => {
                            setReplyingTo(comment.uuid);
                            setReply('');
                        }}>Reply</button>
                    <button type="button" className="button small secondary" disabled={busy}
                        onClick={() => run(() => onVisibility(comment.uuid, !comment.isVisible))}>
                        {comment.isVisible ? 'Hide' : 'Show'}
                    </button>
                </div>
                {replyingTo === comment.uuid && <div className="content-comment-reply">
                    <label htmlFor={`comment-reply-${comment.uuid}`}>Reply</label>
                    <textarea id={`comment-reply-${comment.uuid}`} value={reply}
                        onChange={event => setReply(event.target.value)} />
                    <div className="content-dialog-actions">
                        <button type="button" className="button secondary"
                            onClick={() => setReplyingTo('')}>Cancel</button>
                        <button type="button" className="button"
                            disabled={busy || !reply.trim()}
                            onClick={() => run(async () => {
                                await onReply(comment.uuid, reply.trim());
                                setReplyingTo('');
                                setReply('');
                            })}>Send reply</button>
                    </div>
                </div>}
            </li>)}
        </ol>
        {meta.hasNext && <button type="button" className="button secondary" disabled={busy}
            onClick={() => run(onLoadMore)}>Load more comments</button>}
    </section>;
}
